/**
 * NOTE on the backend/frontend split of responsibility (post GET /api/vocabularies/languages):
 * The BACKEND is the single source of truth for which language codes actually have vocabulary
 * data (see VocabularyService.supportedLangCodes, populated from that endpoint at startup).
 * This file only supplies presentation metadata (flag, native label, CLDR locale id) that the
 * backend has no concept of, plus a static fallback used when the backend call hasn't resolved
 * yet or fails. Adding a language here does NOT make it selectable — it only gets a flag/label
 * ready for the day the backend actually supports it (see ISO639_1LanguagesEnum on the backend).
 */
export interface AppLanguage {
	code: string;
	label: string;
	flag: string;
	isDefault: boolean;
	localeId: string;
}

/** Known languages the frontend has presentation metadata for. NOT the availability source of truth — see note above. */
export const APP_LANGUAGES: AppLanguage[] = [
	{ code: 'it', label: 'Italiano', flag: '🇮🇹', isDefault: true, localeId: 'it-IT' },
	{ code: 'en', label: 'English', flag: '🇬🇧', isDefault: false, localeId: 'en-US' },
	{ code: 'fr', label: 'Français', flag: '🇫🇷', isDefault: false, localeId: 'fr-FR' },
	{ code: 'es', label: 'Español', flag: '🇪🇸', isDefault: false, localeId: 'es-ES' },
	{ code: 'de', label: 'Deutsch', flag: '🇩🇪', isDefault: false, localeId: 'de-DE' },
	{ code: 'pt', label: 'Português', flag: '🇵🇹', isDefault: false, localeId: 'pt-PT' },
];

/** Static fallback used only if the backend's supported-languages call fails or hasn't resolved yet. */
export const SUPPORTED_LANG_CODES: string[] = APP_LANGUAGES.map(l => l.code);

export const DEFAULT_LANGUAGE: AppLanguage = APP_LANGUAGES.find(l => l.isDefault) || APP_LANGUAGES[0];
